// extracted by mini-css-extract-plugin
module.exports = {"userLabel":"top-bar_userLabel__3xPZ5","topBar":"top-bar_topBar__2Xznu","topBarHeading":"top-bar_topBarHeading__3LmnX","logo":"top-bar_logo__35Jmg","avatar":"top-bar_avatar__31wd4"};